import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions } from "firebase/functions"; // connectFunctionsEmulator desactivado (ver abajo)
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyCVtxctu7uqmvtLR7lQuM-v0BGieqFtmu8",
    authDomain: "apuestafacil-webapp.firebaseapp.com",
    projectId: "apuestafacil-webapp",
    storageBucket: "apuestafacil-webapp.appspot.com",
    messagingSenderId: "806777148827",
    appId: "1:806777148827:web:61672ae92930f001a67d3e",
    measurementId: "G-GJN2YHKSVP"
};

const app = initializeApp(firebaseConfig);

// --- FIREBASE APP CHECK (anti-abuso) ---
// Se inicializa lo antes posible tras la app, ANTES de que otros servicios llamen.
// Gated por env: si no hay site key, se omite (no rompe desarrollo).
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (RECAPTCHA_SITE_KEY) {
    // Debug token opcional para entornos locales (genéralo en la consola App Check).
    if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
        // eslint-disable-next-line no-restricted-globals
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
    }
    try {
        initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
            isTokenAutoRefreshEnabled: true
        });
    } catch (e) {
        console.error('[appcheck] init error:', e && e.message);
    }
}

export const auth = getAuth(app);
// Initialize Firestore with settings to improve connectivity
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});
export const rtdb = getDatabase(app);
export const functions = getFunctions(app, 'us-central1');

// NOTA: Emulador de funciones desactivado a propósito. Incluso en desarrollo local
// (localhost:3000) apuntamos directamente a las Cloud Functions de producción en la nube.
// Esto evita los errores de CSP/conexión contra http://localhost:5001 cuando no hay
// emulador corriendo. Para volver a usar el emulador, descomenta el bloque inferior.
// if (window.location.hostname === "localhost") {
//     connectFunctionsEmulator(functions, "localhost", 5001);
// }

export default app;
